<template>
  <div class="page-wrap">

    <section>
      <div class="me-top-box">
        <van-row>
          <van-col span="6">
            <img :src="wx_user.headimgurl" alt="" class="avatar" v-if="hasWechat">
            <img src="../assets/images/me-avatar.png" alt="" class="avatar" v-else>
          </van-col>
          <van-col span="10">

            <div class="me-top-title">
              <span>{{user.name}}</span>
              <span>{{username || "未知电话"}}</span>
            </div>
          </van-col>
          <van-col span="8">
            <i class="van-icon van-cell__right-icon van-icon-arrow"><!----></i>
          </van-col>
        </van-row>
      </div>
    </section>

    

    <section>
      <van-cell-group>
        
        <van-cell title="参保人管理" is-link @click="showList = true" class="items">
          <template slot="icon">
            <img src="../assets/images/我@2x.png">
          </template>
        </van-cell>
        <!-- <van-cell title="待支付账单" is-link class="items" @click="$router.push('/orders?active=1')">
          <template slot="icon">
            <img src="../assets/images/待支付.png">
          </template>
        </van-cell> -->
        <van-cell title="订单查询" is-link class="items" @click="$router.push('/orders')">
          <template slot="icon">
            <img src="../assets/images/订单@2x.png">
          </template>
        </van-cell>
        <!--
        <van-cell title="服务大厅进度" is-link class="items" @click="$router.push('/service-orders/0')">
          <template slot="icon">
            <img src="../assets/images/服务大厅@2x.png">
          </template>
        </van-cell>
-->
        <van-cell title="优惠券列表" is-link class="items" to="/coupons">
          <template slot="icon">
            <img src="../assets/images/coupon.png">
          </template>
        </van-cell>
       
        <!--
        <van-cell title="收件地址设置" value="" is-link class="items">
          <template slot="icon">
            <img src="../assets/images/更多@2x.png">
          </template>
        </van-cell>
        -->
      </van-cell-group>
    </section>
    <section>
      <van-cell-group>
         <van-cell title="邀请好友" is-link class="items" @click="$router.push('/gift')">
          <template slot="icon">
            <img src="../assets/images/s-material.png">
          </template>
        </van-cell>
 
         <van-cell title="我的分享码" is-link @click="qrCodeShow = true" class="items">
          <template slot="icon">
            <img src="../assets/images/二维码.png">
          </template>
        </van-cell>
        <van-cell title="分享记录" is-link class="items" @click="$router.push('/gift-status')">
          <template slot="icon">
            <img src="../assets/images/s-material.png">
          </template>
        </van-cell>
      
      </van-cell-group>
    </section>
    <van-popup v-model="qrCodeShow" class="qr-code-pop">
      <img :src="url"/>
      <div>长按可分享您的个人二维码</div>
    </van-popup>

    <section>
      <van-cell-group>
        <!-- <van-cell title="修改密码" value="" is-link class="items" to="/reset">
          <template slot="icon">
            <img src="../assets/images/me-icon-safe.png">
          </template>
        </van-cell> -->
        <van-cell title="绑定手机" value="" is-link class="items" to="/bind">
          <template slot="icon">
            <img src="../assets/images/me-icon-phone.png">
          </template>
        </van-cell>
        <van-cell title="关于我们" is-link class="items" to="/about">
          <template slot="icon">
            <img src="../assets/images/me-icon-about.png">
          </template>
        </van-cell>
        <van-cell title="联系我们" is-link class="items" to="/con">
          <template slot="icon">
            <img src="../assets/images/watress.png">
          </template>
        </van-cell>
      </van-cell-group>
    </section>

    <section>


      <van-button class="logout" @click="logout">退出当前账号</van-button>
    </section>
    
    <van-popup v-model="showList" position="bottom">
      <sby-profile-list
        :list="profiles"
        @edit="showEditProfile"
        @add="showEditProfile"
        @onDelete="deleteList"
        add-text="添加参保人"
      />
    </van-popup>

<van-popup v-model="showEdit" v-if="showEdit" position="bottom">
    <sby-profile-edit
      @saved="savedProfile"
      @cancel="showEdit = false"
      :editProfile="editProfile"
    >
    </sby-profile-edit>
</van-popup>


  </div>
</template>

<script>
import {
  NavBar,
  Button,
  Row,
  Col,
  Field,
  CellGroup,
  Toast,Dialog,
  Checkbox,
  Popup,
  CheckboxGroup,
  Cell
} from "vant";
import _ from 'lodash';
import axios from 'axios';


export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [Popup.name]: Popup
  },
  props: ["message"],
  name: "services",
  data: function() {
    return {
      user: {},
      showList: false,
      profiles: [],
      editProfile: null,
      url: null,
      showEdit: false,
      qrCodeShow: false,
    };
  },
  computed: {
    hasWechat() {
      return this.user && !_.isEmpty(this.user.wx_user);
    },
    wx_user() {
      return this.hasWechat && this.user.wx_user;
    },
    username() {
      if (this.user && this.user.username && this.user.username.length > 13) {
        return '微信用户';
      } else {
        return this.user && this.user.username;
      }
    }
  },
  methods: {
    currentUser: function() {
      return this.$store.state.user;
    },
    logout: function() {
      Dialog.confirm({
        title: "确认",
        message: "你确认注销么?"
      }).then(()=>{
        this.$http.post("/api/user/logout").then((res)=> {
          this.$store.commit('logout');
          this.$router.replace('/enter');//直接跳转到首页
        }).catch((err) => {
          // on cancel
          this.$store.commit('logout');
          this.$router.replace('/enter');//直接跳转到首页
        })
      })
    },
    loadProfiles() {
      this.$http.get('/api/profile/list')
        .then(response => {
          if (response) {
            this.profiles = response.data.data;
          }
        });
    },
    showEditProfile(item) {
      this.showEdit = true
      this.editProfile = item
    },
    savedProfile(){
      this.showEdit = false
      this.loadProfiles()
    },
    // 删除参保人
    deleteList: function(id) {
      Dialog.confirm({
        message: '确定删除吗？'
      }).then(() => {
        this.$http.get(`/api/profile/delete?id=${id}`)
          .then((response) => {
            if (response) {
            }
            this.loadProfiles();
            Toast("删除成功");
          }).catch((err) => {
            console.error(err);
          });
        console.log(id)
      });
    },
  },
  mounted: function() {
    this.loadProfiles()

    let user = this.$store.state.user;

    if (user.id <= 2) {
      if (!global.vConsole) {
        const Vconsole = require( 'vconsole');
        global.vConsole = new Vconsole()
      }
    }

    if (_.isEmpty(user.wx_user)) {//如果没有
      this.user = user;
      this.$http.get("/api/user/me").then(response => {
        if (response) {
          let user = response.data.data;
          this.user = user;        
        }
      })
    } else {
      this.user = user;
    }

    this.$http.get(`/api/user/qrcode?uid=${user.id}`)
      .then((response) => {
        if (response) {
          let {url, name, avatar} = response.data.data;
          this.url = url;
        }
      }).catch((err) => {
        console.error(err);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/less/var.less";
.debug-box {
  margin-top: 500px;
}
.service-list {
  background-color: white;

  h2 {
    margin: 0;
    font-size: 14px;
    color: @defaultDescColor;
    padding: 15px 15px;
  }
}

.avatar {
  width: 60px;
  height: 60px;
  margin: 20px auto;
  margin-left: 20px;
  border-radius: 50%!important;
}
.qr-code-pop {
  text-align: center;
      width: 90%;
      img {
        width: 100%;
      }
      div {

      font-size: 14px;
    padding-bottom: 15px;
      }
}
.me-top-box {
  background: url('../assets/images/me-topbar.png') no-repeat;
  height: 100px;
  background-size: 100% auto;
  
  
  
  .me-top-title {
    display: inline-block;
    margin: 25px auto;
    span {
      display: block;
      margin-bottom: 10px;
      margin-left: 10px;
    }
  }

  .van-cell__right-icon {
    position: absolute;
    top: 50px;
    right: 15px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    color: white;
    font-size: 12px;
  }
}
section {
  margin-bottom: 10px;
}

.items {
  img {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 10px;
  }
}

.share-box {
  background: url('../assets/images/me-share-bg.png') no-repeat;
  background-size: auto 100% ;

  margin: 10px auto;
  .share-icon {
    width: 40px;
    height: auto;
  }
  .share-box-title {
    line-height: 1rem;
    padding-top: 10px;
    .title {
      display: block;
      font-size: 14px;
    }
    .label {
      font-size: 12px;
      color: @defaultDescColor;
    }
    .value {
      font-size: 12px;
    }
  }
}

button.logout{
  width: 100%;
  border: 0px;
  border-radius: 0px;
  color: #F20707;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/pages/my.vue